<script lang="ts">
  const handleClick = () => {
    window.open('https://calendly.com/infinitrotech/30min', '_blank');
  };
</script>

<style>
  .gradient-bg {
    background: radial-gradient(circle, rgba(59, 130, 246, 1), rgba(59, 130, 246, 0.8));
  }
</style>

<section>
  <button on:click={handleClick}
    class="justify-center px-4 py-3 text-base font-medium leading-5 text-white gradient-bg rounded-full shadow"
    tabindex="0">
    Book a Call
  </button>
</section>